import { Translate } from '@chipinside/translate'
import { Typography } from '@mui/material'
import { TriangleAlert } from 'lucide-react'

import logoHorizontalIcon from '#/assets/layout/logo-horizontal-green-gray.png'
import { UnsupportedBrowserViewProps } from '#/store/services/BrowserGuard/types'
import { ActionButtons } from '#/store/services/BrowserGuard/View/ActionButtons'
import { BypassSection } from '#/store/services/BrowserGuard/View/BypassSection'
import {
  Content,
  Eyebrow,
  Message,
  Sidebar,
  SplitContainer,
  Title,
} from '#/store/services/BrowserGuard/View/styles'
import Palette from '#/styles/Palette'

const PRIMARY = Palette.green.primary[600]
const ERROR = Palette.red.salmon[600]

export function UnsupportedBrowserView({
  canBypass,
  detectedBrowser,
  iconButtonBrowsers,
  matchedBrowser,
  messageKeys,
  minimumBrowser,
  onProceed,
  safariBrowser,
  systemUpdateButton,
  unsupported_feature,
  updateTarget,
}: UnsupportedBrowserViewProps) {
  return (
    <SplitContainer id="browser-guard-unsupported">
      <Sidebar
        sx={{
          backgroundColor: unsupported_feature ? ERROR : PRIMARY,
          color: '#fff',
        }}
      >
        <TriangleAlert size={200} strokeWidth={1} />

        <Typography variant="caption" sx={{ fontSize: 14 }}>
          {Translate({
            messageKey: 'browser_guard_installed_version_label',
          })}
        </Typography>

        <Typography sx={{ fontSize: 20 }}>{detectedBrowser}</Typography>
      </Sidebar>

      <Content>
        {!unsupported_feature && (
          <Eyebrow>{Translate({ messageKey: 'browser_guard_eyebrow' })}</Eyebrow>
        )}

        <Title>{Translate({ messageKey: messageKeys.title })}</Title>

        <Message>
          {Translate({
            messageKey: messageKeys.message,
            params: {
              detectedBrowser,
              minimumBrowser,
            },
          })}
        </Message>

        {messageKeys.benefits && (
          <Message>{Translate({ messageKey: messageKeys.benefits })}</Message>
        )}

        <Message>{Translate({ messageKey: messageKeys.footer })}</Message>

        <ActionButtons
          iconButtonBrowsers={iconButtonBrowsers}
          matchedBrowser={matchedBrowser}
          safariBrowser={safariBrowser}
          systemUpdateButton={systemUpdateButton}
          updateTarget={updateTarget}
        />

        {canBypass && <BypassSection onProceed={onProceed} />}
      </Content>

      <img
        src={logoHorizontalIcon}
        alt="CowMed logo"
        height={60}
        style={{ bottom: 16, position: 'absolute', right: 16 }}
      />
    </SplitContainer>
  )
}
